import React from 'react';
import {
    Header,
    Grid, Segment,
    Button,
    Label,
    Icon, Form, Dropdown, Table, Popup, Card, Placeholder, Divider, Tab, Loader
} from 'semantic-ui-react';
import download from 'downloadjs';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { FiltersOnStyle, IconHeader } from '../../Professor/ProfessorInputGrades/css';
import ReactApexChart from 'react-apexcharts';
import Link from 'react-router-dom/Link';

export default class SimpleOptionsAnswersWithCommentTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showMore: false,
            kom: null

        };
    }

    render() {
        let {
            tableHeader, questionList, tableRibbonLabel, buttonReport, buttonReportText, graphically
        } = this.props;
        return (

            <div>

                {questionList && (questionList.length !== 0) ?

                    questionList.map((el, index) =>
                        (<Table celled selectable compact striped color="blue" >
                            <Table.Header fullWidth>
                                {index === 0 && tableHeader ? <Table.Row >
                                    <Table.HeaderCell colSpan={14} >
                                        <Label ribbon color="blue">{tableRibbonLabel} { localStorage.getItem('numberOfStudentsWhoRatedCourse')}</Label>

                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" colSpan={2} >
                                        {buttonReport && <Header style={IconHeader} textAlign="center" >


                                            <Button

                                                icon="download"
                                                content={buttonReportText}
                                                // labelPosition="right"
                                                color="blue"
                                                size="small"
                                                style={FiltersOnStyle}
                                                onClick={this.printReport}
                                            >

                                            </Button>


                                        </Header>}
                                    </Table.HeaderCell>
                                </Table.Row> : ''}
                                {el.questionType !== 'text' ? <Table.Row>
                                    <Table.HeaderCell width={1} >

                                    </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={7} >
                                        Sadržaj pitanja
                                    </Table.HeaderCell>
                                    { graphically && el.questionType === 'select' && <Table.HeaderCell textAlign="center">
                                        Grafički prikaz
                                    </Table.HeaderCell>}

                                    { el.answerDTOS ? el.answerDTOS.length ?
                                        el.answerDTOS.map((e) => {
                                            if (e.questionName !== 'text') {
                                                if (e.questionName.length < 45) {
                                                    return (<Table.HeaderCell textAlign="center" >
                                                        { e.questionName }
                                                    </Table.HeaderCell>);
                                                }
                                                return (<Popup
                                                    content={e.questionName}
                                                    trigger={<Table.HeaderCell textAlign="center" >
                                                        { e.questionName.substr(0, 30) + '...' }
                                                    </Table.HeaderCell>}
                                                />);
                                            }
                                            return null;
                                        }) : <Table.HeaderCell />
                                        : 'Nema ponuđenih odgovora.'
                                    }
                                    { el.questionType === 'select' &&
                                        <Table.HeaderCell textAlign="center" >
                                            Prosjek
                                        </Table.HeaderCell>
                                    }


                                </Table.Row>
                                    :
                                <Table.Row>
                                        <Table.HeaderCell width={1} colSpan={1}>

                                    </Table.HeaderCell>
                                        <Table.HeaderCell colSpan={15} >
                                        Sadržaj pitanja
                                        </Table.HeaderCell>


                                    </Table.Row>
                                }
                            </Table.Header>
                            <Table.Body>

                                { el.questionType !== 'text' ? <Table.Row >
                                    <Table.Cell verticalAlign="middle" textAlign="center">{index + 1}.</Table.Cell>
                                    <Table.Cell colSpan={7} verticalAlign="middle" >
                                        {el.questionText}
                                    </Table.Cell>
                                    {graphically && el.questionType === 'select' && <Table.Cell verticalAlign="middle" textAlign="center" >
                                        {/* <Icon bordered color="blue" name="chart bar" /> */}
                                        <Dropdown
                                            simple
                                            className="icon"
                                            icon="chart pie"
                                            bordered
                                            color="blue"
                                        >

                                            <Dropdown.Menu>

                                                <Dropdown.Item><Card fluid>
                                                    <Card.Content>

                                                        <div id="chart">
                                                            {/* <ReactApexChart options={this.getOptionForCourseChart(index)} series={this.getSeriesForCourseChart(index)} type="pie" width="400" height="400" /> */}
                                                        </div>
                                                    </Card.Content>
                                                </Card></Dropdown.Item>

                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </Table.Cell>}
                                    { el.answerDTOS ? el.answerDTOS.length ?
                                        el.answerDTOS.map((e) => (e.questionName !== 'text' &&
                                            <Popup
                                                content="Broj odgovora"
                                                trigger={<Table.Cell textAlign="center" verticalAlign="middle">
                                                    { e.numberOfAnswers }
                                                </Table.Cell>}
                                            />


                                        ))
                                        : <Table.Cell />
                                        : 'Nema pitanje.' }
                                    { el.questionType === 'select' &&
                                        <Table.Cell
                                            textAlign="center"
                                            verticalAlign="middle"
                                            warning={parseFloat(el.averagePerQuestion).toFixed(2) >= 2 && parseFloat(el.averagePerQuestion).toFixed(2) <= 4}
                                            positive={parseFloat(el.averagePerQuestion).toFixed(2) > 4}
                                            negative={parseFloat(el.averagePerQuestion).toFixed(2) < 2}
                                        >
                                            {isNaN(el.averagePerQuestion) || parseFloat(el.averagePerQuestion).toFixed(2) === 'NaN' ? '-' : parseFloat(el.averagePerQuestion).toFixed(2)}
                                        </Table.Cell>
                                    }

                                </Table.Row> : <Table.Row >
                                    <Table.Cell verticalAlign="middle" textAlign="center">{index + 1}.</Table.Cell>
                                    <Table.Cell colSpan={15} verticalAlign="middle" >
                                        {el.questionText}
                                    </Table.Cell>
                                </Table.Row>
                                }

                            </Table.Body>
                            {el.answerDTOS.filter((e) => (e.questionName === 'text')).length !== 0 && <Table.Footer>
                                <Table.Row>

                                    <Table.HeaderCell colSpan={el.questionType !== 'text' ? (8 + el.answerDTOS.length - 1) : 16} verticalAlign="middle" textAlign="center">


                                        <Header as="h5">
                                            { el.questionType !== 'text' ?
                                                this.state.kom !== index ? <Button basic color="blue" onClick={() => this.setState({ kom: index })}>Komentari</Button> : <Button basic color="blue" onClick={() => this.setState({ kom: null })}>Zatvori</Button>
                                                : <Button basic color="blue" onClick={() => this.setState({ kom: index })}>Odgovori</Button>}
                                        </Header>


                                    </Table.HeaderCell>


                                </Table.Row>
                                {(el.answerDTOS.length && el.answerDTOS[0].textAnswers) ? el.answerDTOS[0].textAnswers.map((comment, i) => (

                                    this.state.kom === index ? <Table.Row >
                                        <Table.Cell width={1} colSpan={1} verticalAlign="middle" textAlign="center">{i + 1}.</Table.Cell>
                                        <Table.Cell colSpan={el.questionType !== 'text' ? (7 + el.answerDTOS.length - 1) : 15} verticalAlign="middle">{comment || ' '}</Table.Cell>

                                    </Table.Row> : null
                                )) : <Table.Cell colSpan={16} verticalAlign="middle">'Nema komentara'</Table.Cell>}
                            </Table.Footer>
                            }
                        </Table>))

                    : 'Anketa ne sadrži pitanja ove sekcije.'
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Poll/ProfessorPoll/SimpleOptionsAnswersWithCommentTable.js